/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
var deskVoucherReleaseFocus = null;

function deskVoucherPopupOpen($popup, trigger) {
  if (!$popup || !$popup.length) return;
  $popup.fadeIn(100);
  var dialog = $popup.find(".cart-voucher-edit-popup")[0];
  if (deskVoucherReleaseFocus || !window.DeskA11y || !dialog) return;
  deskVoucherReleaseFocus = window.DeskA11y.trapFocus(dialog, {
    returnFocusTo: trigger,
  });
}

function deskVoucherPopupClose() {
  $(".cart-voucher-edit-popup-wrap").fadeOut(100);
  if (deskVoucherReleaseFocus) {
    deskVoucherReleaseFocus();
    deskVoucherReleaseFocus = null;
  }
}

$(document).on("click", ".voucher-cart-edit", function (e) {
  e.preventDefault();
  var $cartItem = $(this).closest(".cart-item");
  var cartItemID = $cartItem.attr("data-key");

  var from = $cartItem.find(".voucher-option-from .voucher-options-value").text();
  var to = $cartItem.find(".voucher-option-to .voucher-options-value").text();
  var msg = $cartItem.find(".voucher-option-msg").text();
  var lang = $cartItem.find(".voucher-option-lng").text();

  var $popup = $(".cart-voucher-edit-popup-wrap");
  var $fromInput = $popup.find(".voucher-popup-edit-cart-from");
  var $toInput = $popup.find(".voucher-popup-edit-cart-to");
  var $msgInput = $popup.find("textarea");

  $msgInput.val(msg !== "-" ? msg : "");
  $fromInput.val(from !== "-" ? from : "");
  $toInput.val(to !== "-" ? to : "");

  $popup.find(".vouhcer-cart-edit-lang").val(lang);
  $popup.find(".cart-voucher-edit-update").attr("data-id", cartItemID);

  $popup
    .find(".voucher-popup-edit-cart-input, .cart-voucher-edit-msg")
    .each(function () {
      var $field = $(this);
      var hasValue = $.trim($field.val()) !== "";
      var $placeholder = $field.next(".placeholder");
      $placeholder.toggleClass("not-empty", hasValue);
      $placeholder.toggleClass("empty", !hasValue);
      $field.toggleClass("hasValue", hasValue);
      $field.closest(".form_input-line").toggleClass("hasValue", hasValue);
    });

  deskVoucherPopupOpen($popup, this);
});

$(document).on(
  "click",
  ".cart-voucher-edit-cancel, .cart-voucher-edit-popup-close",
  function (e) {
    e.preventDefault();
    deskVoucherPopupClose();
  },
);

$(document).on("click", ".cart-voucher-edit-overlay", function (e) {
  if (e.target === this) deskVoucherPopupClose();
});

$(document).on("click", ".cart-voucher-edit-popup", function (e) {
  e.stopPropagation();
});

$(document).on("keydown", function (e) {
  if (e.key === "Escape" && $(".cart-voucher-edit-popup-wrap").is(":visible")) {
    deskVoucherPopupClose();
  }
});

$(document).on(
  "input",
  ".cart-voucher-edit-popup-content .voucher-popup-edit-cart-input, .cart-voucher-edit-popup-content .cart-voucher-edit-msg",
  function () {
    var $field = $(this);
    var hasValue = $.trim($field.val()) !== "";
    $field
      .next(".placeholder")
      .toggleClass("not-empty", hasValue)
      .toggleClass("empty", !hasValue);
    $field.toggleClass("hasValue", hasValue);
    $field.closest(".form_input-line").toggleClass("hasValue", hasValue);
  },
);

$(document).on("click", ".cart-voucher-edit-update", function (e) {
  e.preventDefault();
  var key = $(this).attr("data-id");
  var properties = {};

  var fromVal = $(".cart-voucher-edit-popup .voucher-popup-edit-cart-from").val()?.trim();
  var toVal = $(".cart-voucher-edit-popup .voucher-popup-edit-cart-to").val()?.trim();
  var msgVal = $(".cart-voucher-edit-popup textarea").val()?.trim();
  var langVal = $(".cart-voucher-edit-popup .vouhcer-cart-edit-lang").val()?.trim();

  properties._voucherFrom = fromVal || "";
  properties._voucherTo = toVal || "";
  properties._voucherMessage = msgVal || "";
  properties._voucherLang = langVal || "";

  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/change.js",
    data: {
      id: key,
      properties: properties,
    },
    dataType: "json",
    success: function (cart) {
      console.log("Cart updated", cart);
      deskVoucherPopupClose();

      // /cart puslapyje drawer atnaujinimo nepakanka — reikia atnaujinti patį puslapį
      if (window.location.pathname === "/cart") {
        window.location.reload();
        return;
      }

      window.refreshCartDrawer();
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    },
    error: function (xhr, textStatus, errorThrown) {
      console.error("Error updating cart:", textStatus, errorThrown, xhr.responseJSON);
    },
  });
});